import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import { TabView, TabPanel } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import "primeicons/primeicons.css";
import "../../styles/custom-tabview.css";
import axios from "axios";

import { Dialog } from "primereact/dialog";

import NouvellesFiches from "./nouvellesFiches";
import Visites from "./visitesDem";
import Devis from "./devisDem";
import Toutes from "./toutesDem";
import Suivis from "./suivisDem";
import Agenda from "./agendaDem";
import Demenagement from "./demenagementDem";
import DemenagementFinis from "./demenagementFinis";
import HistoriqueMailsDem from "./historiqueMailsDem"; 

import convertTimeStringToDate from "../timeToDate";
import HeaderDem from "./headerDem";

const TABS = [
  { label: "Nouvelles", key: "nouvelles" },
  { label: "Visites", key: "visites_en_attente" },
  { label: "Devis",    key: "visites_planifiees" },
  { label: "Suivis",   key: "devis_suivis" },
  { label: "Agenda",  key: "agenda" },
  { label: "Déménagement",  key: "demenagements_a_venir" },
  { label: "F",  key: "demenagements_realises" },
  { label: "Toutes",      key: "toutes" },
];



const apiUrl = process.env.REACT_APP_API_URL;
export default function FicheDemandeListe() {
const [activeIndex, setActiveIndex] = useState(() => {
  const stored = localStorage.getItem("activeTabIndexFicheDem");
  return stored ? parseInt(stored, 10) : 0;
});
  const [showHistorique, setShowHistorique] = useState(false);

 const [counters, setCounters] = useState({
   nouvelles: 0,
   visites_en_attente: 0,
   visites_planifiees: 0,
   devis_suivis: 0,
   agenda: 0,
   demenagements_a_venir: 0,
   demenagements_realises:0,
   toutes: 0,
 });

 const [globalSearch, setGlobalSearch] = useState("");

 const handleTabChange = (index) => {
  setActiveIndex(index);
  localStorage.setItem("activeTabIndexFicheDem", index);
};
 
 useEffect(() => {
    axios.get(`${apiUrl}/IHM/api/ficheDem.php?pannelDem=true`)
      .then(res => setCounters(res.data))
      .catch(err => console.error("Erreur compteurs:", err));
  }, [activeIndex]);


  const [demenagement, setDemenagement] = useState([]);

  const [displaySmsPopup, setDisplaySmsPopup] = useState(false);
  const [smsList, setSmsList] = useState([]);


const [displayRejectedPopup, setDisplayRejectedPopup] = useState(false);
const [rejectedDevisList, setRejectedDevisList] = useState([]);
const [dismissedRejected, setDismissedRejected] = useState(false);


  const isDemDateClose = (dateDem) => {
    if (!dateDem || dateDem === "0000-00-00") {
      return false;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const demDate = new Date(dateDem);
    demDate.setHours(0, 0, 0, 0);

    const diffTime = demDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays > 0 && diffDays <= 3;
  };

  useEffect(() => {
    axios
      .get(`${apiUrl}/IHM/api/ficheDem.php?ficheDemenagement`)
      .then((response) => {
        setDemenagement(response.data);
      })
      .catch((error) => {
        console.error("Erreur lors du chargement des factures :", error);
      });
  }, []);

  useEffect(() => {
    const toSend = demenagement.filter(
      (rowData) => rowData.sms != 1 && isDemDateClose(rowData.dateDem)
    );

    if (toSend.length > 0) {
      setSmsList(toSend);
      setDisplaySmsPopup(true);
    } else {
      setDisplaySmsPopup(false);
    }
  }, [demenagement,activeIndex]);


  const tabPanels = [
    "Nouvelles",
    "Visites",
    "Devis",
    "Suivis",
    "Agenda",
    "Déménagement",
    "F",
    "Toutes",
  ];

  useEffect(() => {
    if (showHistorique && activeIndex < tabPanels.length) {
      setShowHistorique(false);
    }
  }, [activeIndex, showHistorique]);


useEffect(() => {
  if (!dismissedRejected) {
    axios
      .get(`${apiUrl}/IHM/api/checkEnvoi/check_rejected_devis.php`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setRejectedDevisList(response.data);
          setDisplayRejectedPopup(true);
        } else {
          setDisplayRejectedPopup(false);
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la vérification des devis rejetés:", error);
      });
  }
}, [dismissedRejected, activeIndex]);


  const handleHistoriqueClick = () => {
    setShowHistorique(true);
    setActiveIndex(tabPanels.length);
  };

  return (
    <div className="relative">
      <HeaderDem
        rejectedDevisList={rejectedDevisList}
        displayRejectedPopup={displayRejectedPopup}
        dismissedRejected={dismissedRejected}
        setDisplayRejectedPopup={setDisplayRejectedPopup}
      />

      <Dialog
        blockScroll
        header="Des devis n'ont pas été reçus !"
        onHide={() => {
          // Ne rien faire - empêcher la fermeture
          return;
        }}
        visible={displayRejectedPopup}
        style={{ width: "50vw", backgroundColor: "#fff" }}
        headerStyle={{
          backgroundColor: "#dc2626",
          color: "white",
          borderBottom: "none",
        }}
        closable={false}
        footer={
          <Button
            label="J'ai compris, je vais les renvoyer"
            icon="pi pi-check"
            severity="danger"
            onClick={() => {
              setDisplayRejectedPopup(false);
            }}
            autoFocus
          />
        }
      >
        <p>
          Les devis suivants n'ont pas été reçus.
          <br />
          Cela signifie que l'email n'a pas pu être délivré.
        </p>
        <ul>
          {rejectedDevisList.map((item) => (
            <li
              key={item.id}
              style={{
                marginBottom: "8px",
                borderBottom: "1px solid #eee",
                padding: "8px 0",
              }}
            >
              <b>{item.numero_devis}</b>
              <br />
              <span>
                Client : <b>{item.nom || "Non renseigné"}</b>
              </span>
              <br />
              <span>Email : {item.email}</span>
              <br />
              <span>Téléphone : {item.telephone || "Non renseigné"}</span>
              <br />
              <small style={{ color: "#666" }}>
                Envoyé le {new Date(item.date_envoi).toLocaleString("fr-FR")}
              </small>
            </li>
          ))}
        </ul>
        <p style={{ color: "#dc2626", fontSize: "14px", marginTop: "10px" }}>
          Un nouveau devis doit être envoyé à ces clients.
        </p>
      </Dialog>

      <Dialog
        blockScroll
        header="Vous avez des SMS à envoyer !"
        onHide={() => setDisplaySmsPopup(false)}
        visible={displaySmsPopup}
        style={{ width: "50vw", backgroundColor: "#fff" }}
        headerStyle={{
          backgroundColor: "#ef4444",
          color: "white",
          borderBottom: "none",
        }}
        footer={
          <Button
            label="OK, j'ai noté"
            icon="pi pi-check"
            severity="danger"
            onClick={() => setDisplaySmsPopup(false)}
            autoFocus
          />
        }
      >
        <p>
          Les fiches suivantes nécessitent un envoi de SMS car la date de
          déménagement est dans <b>moins de 3 jours </b>:
        </p>
        <ul>
          {smsList.map((item) => (
            <li key={item.idFicheDem} style={{ marginBottom: "5px" }}>
              <b>{item.nom}</b> (Tél: <b>{item.tel}</b>) - Date de déménagement
              :<b>{new Date(item.dateDem).toLocaleDateString("fr-FR")}</b>
            </li>
          ))}
        </ul>
      </Dialog>

      <div
        style={{
          overflowX: "auto",
          overflowY: "visible",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div className="flex flex-column md:flex-row justify-content-between md:align-items-center p-2 gap-3">
          <div
            style={{
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
              scrollbarWidth: "none",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                gap: "4px",
                minWidth: "max-content",
              }}
            >
              {TABS.map((tab, i) => {
                const isActive = i === activeIndex;
                return (
                  <div
                    key={i}
                    onPointerDown={() => handleTabChange(i)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "0 12px",
                      height: "35px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      flexShrink: 0,
                      backgroundColor: isActive ? "#0971b7" : "transparent",
                      touchAction: "manipulation",
                      WebkitTapHighlightColor: "transparent",
                      userSelect: "none",
                    }}
                  >
                    <span
                      style={{
                        color: isActive ? "#fff" : "#6b6b6b",
                        fontWeight: isActive ? 700 : 500,
                        fontSize: "13px",
                      }}
                    >
                      {tab.label}
                    </span>

                    <span
                      style={{
                        marginLeft: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        fontWeight: "bold",
                        fontSize: "10px",
                        width: "18px",
                        height: "18px",
                        backgroundColor: isActive ? "#F8F9FA" : "transparent",
                        color: isActive ? "#0A2540" : "#9a9a98",
                      }}
                    >
                      {counters[tab.key] ?? 0}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Search */}
          <div className="w-full md:w-auto">
            <IconField iconPosition="left">
              <InputIcon className="pi pi-search" />
              <InputText
                value={globalSearch}
                onChange={(e) => setGlobalSearch(e.target.value)}
                placeholder="Rechercher un client..."
                className="w-full md:w-20rem"
              />
            </IconField>
          </div>
        </div>
      </div>

      {/* <TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
        <TabPanel header="Nouvelles">
          <NouvellesFiches />
        </TabPanel>

        <TabPanel header="Visites">
          <Visites />
        </TabPanel>

        <TabPanel header="Devis">
          <Devis />
        </TabPanel>
        <TabPanel header="Suivis">
          <Suivis />
        </TabPanel>
        <TabPanel header="Agenda">
          <Agenda />
        </TabPanel>
        <TabPanel header="Déménagement">
          <Demenagement />
        </TabPanel>
        <TabPanel header="F">
          <DemenagementFinis />
        </TabPanel>
        <TabPanel header="Toutes">
          <Toutes />
        </TabPanel>

        {showHistorique && (
          <TabPanel header="Historique des mails de déménagement">
            <HistoriqueMailsDem />
          </TabPanel>
        )}
      </TabView> */}

      <div style={{ padding: "1rem 0 0 0" }}>
        {activeIndex === 0 && <NouvellesFiches searchTerm={globalSearch} />}
        {activeIndex === 1 && <Visites searchTerm={globalSearch} />}
        {activeIndex === 2 && <Devis searchTerm={globalSearch} />}
        {activeIndex === 3 && <Suivis searchTerm={globalSearch} />}
        {activeIndex === 4 && <Agenda searchTerm={globalSearch} />}
        {activeIndex === 5 && <Demenagement searchTerm={globalSearch} />}
        {activeIndex === 6 && <DemenagementFinis searchTerm={globalSearch} />}
        {activeIndex === 7 && <Toutes searchTerm={globalSearch} />}
      </div>
    </div>
  );
}
